<template>
  <div>
    <v-row>
      <v-col cols="12">
        <px-gestao-entrega-produto-dividir-saldo-dialog :saldos="saldos"
                                                        :compra-produto="compraProduto"
                                                        @change="onChangeSaldo">
          <template v-slot:activator="{ on }">
            <v-btn small
                   class="rounded-tag-small normal-btn-text elevation-0"
                   v-on="on">
              <v-icon small left>
                mdi-arrow-split-vertical
              </v-icon>
              Dividir saldo
            </v-btn>
          </template>
        </px-gestao-entrega-produto-dividir-saldo-dialog>
      </v-col>
    </v-row>
    <template v-for="(saldo, index) in saldos">
      <px-gestao-entrega-produtos-compras-item-content-saldo-row
        :key="`row-${saldo.id}`"
        :saldo="saldo"
        :compra-produto="compraProduto"
        :controla-faturamento="controlaFaturamento"
        @change="onChangeSaldo"/>
      <v-divider :key="`div-${saldo.id}`" v-if="index !== saldos.length - 1"/>
    </template>
  </div>
</template>

<script>

import GestaoEntregaProdutosComprasItemContentSaldoRow
  from '@/modules/gestao-entregas/GestaoEntregaProdutosComprasItemContentSaldoRow.vue';
import pxGestaoEntregaProdutoDividirSaldoDialog
  from '@/modules/gestao-entregas/GestaoEntregaProdutoDividirSaldoDialog.vue';

export default {
  props: {
    compraProduto: Object,
    controlaFaturamento: {
      type: Boolean,
      default: false,
    },
    saldos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onChangeSaldo(data) {
      this.$emit('change', data);
    },
  },
  components: {
    pxGestaoEntregaProdutoDividirSaldoDialog,
    pxGestaoEntregaProdutosComprasItemContentSaldoRow:
    GestaoEntregaProdutosComprasItemContentSaldoRow,
  },
};
</script>
